import { ButtonUnstyled, IconAtom } from "../../atoms";

interface Props {
  index: number;
  result: any;
  tableIndex: number;
  dossierView: boolean;
  onClick: (index: number, setIndex: number) => void;
  isSelected: boolean;
}

export function ContentRow(props: Readonly<Props>) {
  const isFirstItem = props.index === 0;
  const isDossierView = props.dossierView;
  return (
    <div style={{ display: "flex" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        {!isFirstItem && <IconAtom icon="paper-clip" type=".png" size="large" alt="" style={{ marginRight: "12px" }} />}

        {!isDossierView && <input type="radio" name="document" checked={props.isSelected} />}
      </div>
      <div className={"title"}>
        <ButtonUnstyled
          id={`document_upload_${props.index}_${props.tableIndex}`}
          onClick={() => props.onClick(props.index, props.tableIndex)}
        >
          {documentTitle(props.result, props.index)}
        </ButtonUnstyled>
      </div>
    </div>
  );
}

const documentTitle = (result: any, index: number) =>
  result?.meta?.document?.titelcollectie?.officieleTitel || (index === 0 ? "Hoofddocument" : `Bijlage ${index}`);
